module.exports = __webpack_public_path__ + "img/运营发布.586133e3.png";